import Descriptions from 'antd/lib/descriptions';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { displayTextForReleaseMethod } from '../../helpers/displayHelpers';
import { RootState } from '../../reducers/reducers';
import { selectAppStoreDefaults } from '../../selectors/selectors';
import { AppleAppStoreDefaultSettings } from '../../types';
import { AppComponentProps } from '../../typescriptHelpers';

interface AppleAppStoreReleaseDefaultsDescriptionsProps extends AppComponentProps {
    bordered?: boolean;
    labelStyle?: React.CSSProperties;
    contentStyle?: React.CSSProperties;
}

const AppleAppStoreReleaseDefaultsDescriptions: React.FC<AppleAppStoreReleaseDefaultsDescriptionsProps> = (
    props: AppleAppStoreReleaseDefaultsDescriptionsProps,
) => {
    const appStoreDefaults = useSelector((state: RootState) =>
        selectAppStoreDefaults(state, props.appId),
    ) as AppleAppStoreDefaultSettings;

    // const resetRatingText = appStoreDefaults?.resetSummaryRating ? 'Reset rating' : 'Keep existing rating';
    const encryptionText =
        appStoreDefaults ?
            appStoreDefaults.exportComplianceInfoUsesEncryption ?
                'Yes, my app uses non-exempt encryption'
            :   'No, my app does not use non-exempt encryption'
        :   'Not set';

    const releaseMethodText =
        appStoreDefaults ? displayTextForReleaseMethod(appStoreDefaults.releaseMethod) : 'Not set';

    const phasedReleaseText =
        appStoreDefaults ?
            appStoreDefaults.phasedRelease === true ?
                'Release updates over 7-day period using phased release'
            :   'Release updates to all users immediately'
        :   'Not set';

    return (
        <Descriptions
            column={1}
            labelStyle={props.labelStyle}
            contentStyle={props.contentStyle}
            colon={false}
            bordered={props.bordered}
        >
            {/* <Descriptions.Item label="Reset summary rating">{resetRatingText}</Descriptions.Item> */}
            <Descriptions.Item label="Export compliance information">{encryptionText}</Descriptions.Item>
            <Descriptions.Item label="Release method">{releaseMethodText}</Descriptions.Item>
            <Descriptions.Item label="Phased release">{phasedReleaseText}</Descriptions.Item>
        </Descriptions>
    );
};

export default AppleAppStoreReleaseDefaultsDescriptions;
